/**
 * @file Unit update page: one unit's details, default charge templates and related entities, opening the increase-rent coach.
 * Failure path: each saga's `onError` resets the saving flag, and the saga shows the message.
 */
import * as React from "react";
import * as ReactDOM from "react-dom";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { PAYMENT_ROUTE } from "../../../Entity/Entities/Charge/PaymentRoute";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import { ContractListing } from "../../Partials/Listing/ContractListing";
import { BalanceComponent } from "../../Partials/Balance/BalanceComponent";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import { CoachAgencyFee } from "../../Partials/Dialog/CoachAgencyFee";
import { AgencyFeeUpdate } from "../../Partials/Dialog/AgencyFeeUpdate";
import TextField from "../../Partials/Material/TextField";
import Select from "../../Partials/Material/Select";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Formatter from "../../../Localization/Formatter";
import UnitUpdateWillMount from "../../../Middleware/Middlewares/UnitUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import UnitServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/UnitServiceStatusTypeContainer";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { ArchiveEntityPrompt } from "../../Partials/Dialog/ArchiveEntityPrompt";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
// import { AbstractPane } from "../../Partials/AbstractPane/AbstractPane";
// import { AlertsComponent } from "../../Partials/Alert/AlertsComponent";
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import Memo from "../../Partials/Memo/Memo";
import UnitCard from "../../Partials/Unit/UnitCard";
import { Attachment } from "../../Partials/Attachment/Attachment";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import { CoachIncreaseRentDialog } from "../../Partials/Dialog/CoachIncreaseRentDialog";
import AgreementCard from "../../Partials/Agreement/AgreementCard";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";
import { CoachMoveUnitDialog } from "../../Partials/Dialog/CoachMoveUnitDialog";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";
import { CoachNewContractDialog } from "../../Partials/Dialog/CoachNewContractDialog";

import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";

class UnitUpdate extends Component {
  protected selectedAgencyFee: AgencyFeeInterface;
  public noteField: null;

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_UNIT_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    UnitUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    events: [],
    eventsForContracts: [],
    charges: [],
    chargesForContracts: [],
    tasks: [],
    fetchingEvents: true,
    fetchingTasks: true,
    isSaving: false,
    attachments: [],
    removed: false,
    unit: null,
    id: null,
    unitNumber: "",
    unitType: 1,
    unitServiceStatus: UnitServiceStatusTypeContainer.pickIdFromLabel("MANAGEMENT"),
    squareMeters: "",
    roomNumber: "",
    bedroomNumber: "",
    bathroomNumber: "",
    publicationTitle: "",
    note: "",
    amazonFolderName: "",
    filterValue: this.props.location.search.includes("unpaid") ? "unpaid" : "all",
    nextPath: "",
    agencyFee: null,
    anchorElAgencyFees: null,
    isAgencyFeeDialogOpen: false,
    isAgencyRemoveDialog: false,
    isUpdating: false,
    deletedCharge: null,
    removedPayments: [],
    selectedTabIndex: 0,
    hasModifiedData: false,
    active: true,
    openLeavePrompt: false,
    anchorUnitEl: null,
    showOnlyInactiveDeletingDialog: false,
    isDeletePromptOpen: false,
    isArchivePromptOpen: false,
    memoPopupOpen: false,
    isCreateTasksFromActivityTemplatePopupOpen: false,
    currentActivityTemplate: null,
    currentTenant: null,
    isLaunchPanelOpen: false,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    selectedEntityForCharge: null,
    openChargeCreatePopupLaunchPanel: false,
    accordionPresentationUnit: false,
    unitIdForDetailsPresentation: null,
    isErrorLaunchPanelOpen: false,
    isNewTaskPopupOpen: false,
    openCoachIncreaseRent: false,
    agrementIdForDetailsPresentation: null,
    openCoachMoveUnit: false,
    isUnitHasActiveContractPopupOpen: false,
    showAllFields: false,
    openCoachCreateNewContact: false,

    // charge templates
    isDefaultChargeTemplatePopupOpen: false,
    isChargeTemplatePopupOpen: false,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    cannotDeleteSavingsChargeDialog: false,
    unitServiceStatusDilaogOpen: false,

    // Default agreement
    defaultAgencyFee: null,
    fixedFee: "",
    percentageFee: "",
    fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
    agreementVat: "",
    vatPercentage: "",
    chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
    repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
    assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    vat: ""
  }

  constructor(public props) {
    super(props);

    this.delete = this.delete.bind(this);
    this.archive = this.archive.bind(this);
    this.save = this.save.bind(this);
    this.done = this.done.bind(this);
    this.openAgencyFeeDialog = this.openAgencyFeeDialog.bind(this);
    this.closeAgencyFeeDialog = this.closeAgencyFeeDialog.bind(this);
    this.addAgencyFee = this.addAgencyFee.bind(this);
    this.saveAgencyFee = this.saveAgencyFee.bind(this);
    this.updateAgencyFee = this.updateAgencyFee.bind(this);
    this.deleteAgencyFee = this.deleteAgencyFee.bind(this);
    this.deletePayment = this.deletePayment.bind(this);
    this.deleteCharge = this.deleteCharge.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.delete = this.delete.bind(this);
    this.changeFilterChargeValue = this.changeFilterChargeValue.bind(this);
  }

  public initializePage = (unit: UnitInterface) => {
    if (!unit) {
      return this.redirectBack();
    }

    const usingBeta: boolean = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta;

    this.fetchEntityEvents(unit.id);
    this.fetchUnitContractsEvents(unit);
    this.fetchUnitCharges(unit.id);
    this.fetchUnitContractsCharges(unit.id);

    this.props.dispatch({
      type: Constants.GLOBAL_UNIT_UPDATE_CLEAR
    });

    let selectedTabIndex = this.props.app.unitUpdatePageTabIndex;

    if (unit.id !== this.props.app.selectedUnitId) {
      selectedTabIndex = 0;
      this.props.dispatch({
        type: Constants.PAGE_UNIT_UPDATE_SWITCH_TAB,
        payload: {
          index: 0
        }
      });
    }

    const agencyFee = unit?.defaultAgencyFees[0];

    let vatPercentage = "";

    if (agencyFee && agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(agencyFee.vat / (agencyFee.fixedFee - agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = this.formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    this.setState({
      unit: unit,
      id: unit ? unit.id : null,
      unitNumber: unit.unitNumber ? unit.unitNumber : "",
      note: unit.note ? unit.note : "",
      unitType: unit.type ? unit.type.id : null,
      unitServiceStatus: unit.unitServiceStatus?.id,
      squareMeters: unit.squareMeters === null ? "" : unit.squareMeters,
      roomNumber: unit.roomNumber === null ? "" : unit.roomNumber,
      bedroomNumber: unit.bedroomNumber === null ? "" : unit.bedroomNumber,
      bathroomNumber: unit.bathroomNumber === null ? "" : unit.bathroomNumber,
      publicationTitle: unit.publicationTitle === null ? "" : unit.publicationTitle,
      attachments: unit.attachments,
      beta: usingBeta ? usingBeta : null,
      active: !unit.isInactive,
      selectedTabIndex: selectedTabIndex ? selectedTabIndex : 0,
      stepperIndex: 0,
      step3Visibility: "hidden",
      firstName: "",
      lastName: "",
      value: null,
      unitSelected: false,
      personSelected: false,
      amazonFolderName: null,
      openLeavePrompt: false,
      isAgencyFeeDialogOpen: false,
      isUpdating: false,
      //active: true,
      isUnitInactiveDialogOpen: false,
      chargeRemoveSucceedDialogOpen: false,
      removedPayments: [],
      paymentsFailedToRemove: [],
      deletedCharge: null,
      hasModifiedData: false,
      nextPath: "",
      isAgencyRemoveDialog: false,
      agencyFee: null,
      anchorElAgencyFees: null,
      avatar: unit.avatar,
      removed: unit.removed,
      isLaunchPanelOpen: false,
      openChargeCreatePopupLaunchPanel: false,
      isErrorLaunchPanelOpen: false,
      openCoachMoveUnit: false,
      isUnitHasActiveContractPopupOpen: false,

      // charge templates
      isDefaultChargeTemplatePopupOpen: false,
      isChargeTemplatePopupOpen: false,
      anchorElChargeTemplate: null,
      selectedChargeTemplate: null,
      openPostProcessAgencyFeeDialog: false,

      defaultAgencyFee: agencyFee,
      currency: agencyFee ? agencyFee.currency.getCurrencyId() : this.props.app.settings.user.currency.getCurrencyId(),
      fixedFee: agencyFee && ((!agencyFee.fixedFee && agencyFee.fixedFee !== 0) ? "" : this.formatter.simpleFormatNumber(agencyFee.fixedFee)),
      percentageFee: agencyFee ? this.formatter.simpleFormatNumber(agencyFee?.percentageFee, false) : "",
      fixedPlusPercentageMode: agencyFee ? agencyFee.fixedPlusPercentageMode : this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
      agreementVat: agencyFee ? (!agencyFee.vat ? "" : this.formatter.simpleFormatNumber(agencyFee.vat)) : "",
      vatPercentage: vatPercentage ? vatPercentage : "",
      chargeTypeIds: agencyFee?.chargeTypeIds || [TypeContainer.pickIdFromLabel("Basic_rent")],
      repeatPeriod: agencyFee?.repeatPeriod ? agencyFee?.repeatPeriod : PeriodContainer.pickIdFromLabel("monthly"),
      assignmentServiceStatus: agencyFee?.assignmentServiceStatus,
      isConcept: agencyFee?.isConcept,
      agreementRemoved: agencyFee?.removed
    });
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const unit: UnitInterface = nextProps.units.byId[id];
    if (prevId !== id) {
      this.initializePage(unit);
    } else {
      this.setState({
        unit: unit,
        attachments: unit?.attachments
      });
    }
  }

  public fetchEntityEvents = (entityId: number,) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        unitId: entityId
      },
      onSuccess: data => {
        const unitEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);

        this.setState({
          events: [...unitEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public openDefaultChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    return this.setState({
      isDefaultChargeTemplatePopupOpen: true
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    return this.setState({
      isChargeTemplatePopupOpen: true
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isDefaultChargeTemplatePopupOpen: false,
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public changeUnitType = (event) => {
    this.setState({
      unitType: event.target.value,
      hasModifiedData: true
    });
  }

  public changeUnitNumber = (event) => {
    this.setState({
      unitNumber: event.target.value,
      hasModifiedData: true
    });
  }

  public changeUnitSquareMeters = (event) => {
    this.setState({
      squareMeters: event.target.value,
      hasModifiedData: true
    });
  }

  public changeUnitRoomNumber = (event) => {
    this.setState({
      roomNumber: event.target.value,
      hasModifiedData: true
    });
  }

  public changeUnitBedroomNumber = (event) => {
    this.setState({
      bedroomNumber: event.target.value,
      hasModifiedData: true
    });
  }

  public changeUnitBathroomNumber = (event) => {
    this.setState({
      bathroomNumber: event.target.value,
      hasModifiedData: true
    });
  }

  public openUnitInactiveDialog = () => {
    this.setState({
      isUnitInactiveDialogOpen: true
    });
  }

  public updateUnitServiceStatus = (unit) => {
    this.setState({
      unitServiceStatus: unit?.unitServiceStatus?.id,
    });
  }

  public openAgencyFeeDialog() {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog(agreementId = null) {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.setState({
      isAgencyFeeDialogOpen: false,
      isUpdating: false
    }, () => {
      agreementId && this.redirect(`/app/agreement/update/${agreementId}`);
    });
  }

  public selectDate(momentDate: any, identifier: string): any {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date
    });

    this.setModifiedData();
  }

  public delete() {
    this.setState({
      isDeletePromptOpen: false
    });

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_DELETE_START,
        payload: {
          unit: this.state.unit,
          propertyId: this.state.unit && this.state.unit.propertyId
        },
        onSuccess: this.redirectBack,
        onError: () => {
          this.setState({
            isSaving: false
          })
        }
      });
    })
  }

  public archive() {
    this.setState({
      isArchivePromptOpen: false
    });

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START,
        payload: {
          unitId: this.state.unit?.id,
          unitServiceStatusId: UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus ?
            UnitServiceStatusTypeContainer.pickIdFromLabel("MANAGEMENT")
            :
            UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE")
        },
        onSuccess: unit => {
          this.setState({
            isSaving: false,
            isDeletePromptOpen: false
          });

          if (unit) {
            return this.setState({
              unitServiceStatus: unit?.unitServiceStatus?.id
            });
          }
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public save() {
    // In this page, we save default agency fee.
    if (this.state.selectedTabIndex === 3) {
      this.setState({
        isSaving: true
      })
      const payload = {
        id: this.state.defaultAgencyFee?.id,
        objectType: this.state.defaultAgencyFee ? this.state.defaultAgencyFee?.objectType : AgencyFeeContainer.pickIdFromLabel("Unit"),
        objectId: this.state.defaultAgencyFee ? this.state.defaultAgencyFee?.objectId : this.state.unit?.id,
        currency: this.state.currency,
        fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
        percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.agreementVat)).replace(",", ".")).toFixed(2)),
        fixedPlusPercentageMode: this.state.fixedPlusPercentageMode?.id,
        chargeTypeIds: this.state.chargeTypeIds,
        repeatPeriodId: this.state.repeatPeriod,
        serviceStatusId: this.state.assignmentServiceStatus,
      };

      if (payload.id) {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.GLOBAL_AGENCY_FEE_UPDATE_DEFAULT_START,
            payload: {
              ...payload
            },
            onSuccess: (agencyFee: AgencyFeeInterface) => {
              this.setState({
                hasModifiedData: false,
                isSaving: false,
                defaultAgencyFee: agencyFee
              })
            },
            onError: () => {
              this.setState({
                hasModifiedData: true,
                isSaving: false
              })
            }
          });
        });
      } else {
        delete payload.id;
        this.props.dispatch({
          type: Constants.GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START,
          payload: payload,
          onSuccess: (agencyFee: AgencyFeeInterface) => {
            this.setState({
              hasModifiedData: false,
              isSaving: false,
              defaultAgencyFee: agencyFee
            })
          },
          onError: () => {
            this.setState({
              hasModifiedData: true,
              isSaving: false
            })
          }
        });
      }
    } else {
      this.saving(() => {
        return this.props.dispatch({
          type: Constants.GLOBAL_UNIT_UPDATE_START,
          payload: {
            id: this.state.id,
            unit: {
              unitNumber: this.state.unitNumber,
              unitTypeId: this.state.unitType,
              squareMeters: this.convertToInteger(this.state.squareMeters),
              roomNumber: this.convertToInteger(this.state.roomNumber),
              bedroomNumber: this.convertToInteger(this.state.bedroomNumber),
              bathroomNumber: this.convertToInteger(this.state.bathroomNumber),
              publicationTitle: this.state.publicationTitle,
              note: this.state.note
            }
          },
          onSuccess: () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }

            this.setState({
              isSaving: false,
            });
          },
          onError: () => {
            this.setState({
              isSaving: false,
              hasModifiedData: true
            });
          }
        });
      });
    }
  }

  public addChargeTemplate = (chargeTemplate): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_START,
        payload: {
          chargeTemplate: chargeTemplate,
          unitId: this.state.unit && this.state.unit.id
        },
        onSuccess: () => {
          this.closeChargeTemplatePopup();
          // Redirect user to settings tab and scroll to top.
          this.switchTab(null, 3);
          window.scrollTo(0, 0);

          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public openDefaultChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      isDefaultChargeTemplatePopupOpen: true
    });
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      isChargeTemplatePopupOpen: true
    });
  }

  public updateChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
      });

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
      });

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_START,
        payload: {
          chargeTemplate: chargeTemplate
        },
        onSuccess: () => {
          this.closeChargeTemplatePopup();

          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public deleteChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.closeChargeTemplateMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START,
      payload: {
        chargeTemplate: chargeTemplate
      }
    });
  }

  public addAgencyFee(agencyFee): any {
    this.setState({
      isSaving: true
    })
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: () => {
        // this.closeAgencyFeeDialog();
        this.setState({
          isSaving: false
        })
      },
      onError: () => {
        this.setState({
          isSaving: false
        })
      }
    });
  }

  public updateAgencyFee(agencyFee: AgencyFeeInterface): any {
    if (agencyFee?.isReadonly) {
      this.setState({
        anchorElAgencyFees: null
      });

      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("agency_fee_not_concept"),
          type: "warning"
        }
      });
    }

    this.selectedAgencyFee = agencyFee;
    this.setState({
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  public saveAgencyFee(agencyFee: AgencyFeeInterface): any {
    let checkAgencyFeeChargeCreated = this.state.charges.some(charge => {
      return charge.automaticallyCreated && charge.type?.label === "Agency_fee"
    })

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.closeAgencyFeeDialog();

        if (checkAgencyFeeChargeCreated) {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("dialog/postprocess-info/agencyfeeupdate"),
              type: "info"
            }
          })
        }
      }
    });
  }

  public deleteAgencyFee = () => {
    this.saving(() => {
      this.closeMenuAgencyFees();

      const agencyFee = this.state.agencyFee;

      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
        payload: agencyFee,
        onSuccess: () => {
          this.setState({
            isAgencyRemoveDialog: false,
            agencyFee: null,
            isSaving: false
          });
        },
        onError: (e) => {
          if (e.blockingCharge) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("agreement-cannot-be-removed-because-of-locked-charges", { firstDate: this.formatter.formatDate(e.blockingCharge.firstDate), lastDate: this.formatter.formatDate(e.blockingCharge.lastDate) }),
                type: "error"
              }
            });
          }
          this.setState({
            isAgencyRemoveDialog: false,
            agencyFee: null,
            isSaving: false
          });
        }
      });
    })
  }

  public closePrompt(): void {
    this.setState({
      isAgencyRemoveDialog: false,
    })
  }

  protected openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget
    });
  }

  protected closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.selectedAgencyFee = agencyFee;

    this.setState({
      anchorElAgencyFees: event.currentTarget
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a.repeatPeriod.id, b.repeatPeriod.id) ||
      this.comparer(a.type.label, b.type.label);
  }

  public getDefaultChargeTemplates = () => {
    return this.state.unit && [...this.state.unit?.defaultChargeTemplates]
      .sort(this.chargeTemplateComparer)
      .map((chargeTemplate: ChargeTemplateInterface) => {
        return (
          <TableRow
            hover
            key={chargeTemplate.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openDefaultChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{ width: "20%" }}>
              {this.formatter.formatNumber(chargeTemplate.amount, chargeTemplate.currency)}
            </TableCell>
            <TableCell style={{ width: "30%" }}>{!!chargeTemplate.type && Formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{ width: "15%" }}>{Formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell style={{ width: "5%" }}>
              {
                chargeTemplate?.paymentRouteId === PAYMENT_ROUTE.DIRECT_UNTRACKED && (
                  <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="list-label creation-type-label">
                      {this.trans("label-direct")}
                    </div>
                  </div>

                )
              }
            </TableCell>
            <TableCell style={{ width: "30%" }}>{chargeTemplate.description}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openDefaultChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menu/defaultunitchargetemlpate-option/edit")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menu/defaultunitchargetemlpate-option/remove")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public getChargeTemplates = () => {
    return this.state.unit && [...this.state.unit?.chargeTemplates]
      .sort(this.chargeTemplateComparer)
      .map((chargeTemplate: ChargeTemplateInterface) => {
        return (
          <TableRow
            hover
            key={chargeTemplate.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{ width: "20%" }}>
              {this.formatter.formatNumber(chargeTemplate.amount, chargeTemplate.currency)}
            </TableCell>
            <TableCell style={{ width: "30%" }}>{!!chargeTemplate.type && Formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{ width: "15%" }}>{Formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell style={{ width: "5%" }}>{chargeTemplate?.paymentRouteId === PAYMENT_ROUTE.DIRECT_UNTRACKED ? this.trans("label-direct") : ""}</TableCell>
            <TableCell style={{ width: "30%" }}>{chargeTemplate.description}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menu/defaultunitchargetemlpate-option/edit")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menu/defaultunitchargetemlpate-option/remove")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={this.state.isDefaultChargeTemplatePopupOpen ? "default" : "unit"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          isDefault={this.state.selectedChargeTemplate?.isDefault}
          showInformationText={this.state.isChargeTemplatePopupOpen}
          disabled={this.state.isChargeTemplatePopupOpen && this.state.removed}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={this.state.isDefaultChargeTemplatePopupOpen ? "default" : "unit"}
        selectedType={this.state.isDefaultChargeTemplatePopupOpen ? TypeContainer.pickIdFromLabel("Basic_rent") : TypeContainer.pickIdFromLabel("Owner_association_contribution")}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        isDefault={this.state.isDefaultChargeTemplatePopupOpen}
        showInformationText={this.state.isChargeTemplatePopupOpen}
        company={this.state.isChargeTemplatePopupOpen && this.state.unit?.property?.associationOwner}
      />
    );
  }

  public getAgencyFeeDialogContent = (): any => {
    let checkAgencyFeeChargeCreated = this.state.charges.some(charge => {
      return charge.automaticallyCreated && charge.type?.label === "Agency_fee"
    })

    return (
      <AgencyFeeUpdate
        {...this.props}
        agencyFee={this.selectedAgencyFee}
        showDates={true}
        onSave={this.saveAgencyFee}
        onCancel={this.closeAgencyFeeDialog}
        checkAgencyFeeChargeCreated={checkAgencyFeeChargeCreated}
      />
    );
  }

  public renderUnitContractsBalanceSection = (): any => {
    const unitContracts = this.state.unit && this.state.unit.contracts
      .filter((contract: ContractInterface) => contract.removed === false)
      .filter((contract: ContractInterface) => {
        // Filter signed contracts
        return !contract.isConcept && !contract.isDropped && !contract.isClosed;
      })
      .sort((contractA, contractB) => {
        if (contractA.firstDate < contractB.firstDate) {
          return -1;
        }

        if (contractA.firstDate > contractB.firstDate) {
          return 1;
        }

        return 0;
      });

    const unitCombinedContracts = [];
    let relatedContracts = [];

    unitContracts.forEach(contract => {
      if (!contract.nextContractId) {
        relatedContracts.push(contract);
        unitCombinedContracts.push(relatedContracts);
        relatedContracts = [];
      }

      if (contract.nextContractId) {
        relatedContracts.push(contract);

        if (unitContracts.length === 1) {
          unitCombinedContracts.push(relatedContracts);
        }
      }
    });


    return unitCombinedContracts
      .map((contractArr, index: number) => {
        const occupants = contractArr[0].occupants.map(occupant => {
          return `${occupant.person.firstName} ${occupant.person.lastName}`
        })

        return (
          <div key={index} className="component-wrapper no-margins has-margin-bottom">
            <Card className="card no-padding">
              <div className="label-container">
                <h3 className="card-title">
                  {this.trans("section/balance-title/balanceforcontract")}
                </h3>

                <p style={{
                  marginLeft: "65px",
                  fontSize: "12px",
                  marginTop: "-15px",
                  color: "gray"
                }}>
                  {`${this.trans("role-tenant")}: `}{contractArr[0]?.tenantDisplayName}{occupants && occupants.length > 0 && (<span>{`(${this.trans("role-mede-huurder")}: `}{occupants.join(", ")}{")"}</span>)}
                </p>

                <Button
                  color="primary"
                  onClick={() => {
                    if (this.checkProcessIsBusy({
                      action: "create",
                      entityName: "charge",
                      entity: contractArr[contractArr.length - 1]
                    })) {
                      this.openIsBusyPopup();
                    } else {
                      this.props.dispatch({
                        type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                        payload: {
                          contractId: contractArr && contractArr[contractArr.length - 1] && contractArr[contractArr.length - 1].id
                        }
                      });

                      this.openChargeCreatePopup(contractArr[contractArr.length - 1]);
                    }
                  }}
                >
                  {this.trans("section/balance-button/newcharge")}
                </Button>
              </div>

              <BalanceComponent
                {...this.props}
                balanceFor="contract"
                unitCombinedContracts={contractArr}
                relatedContractsBalanceCharges={this.state.chargesForContracts}
                deleteCharge={this.deleteCharge}
                fetchCharges={() => {
                  this.fetchUnitContractsCharges(this.state.unit && this.state.unit.id);
                }}
                unitId={this.state.unit && this.state.unit.id}
                contract={contractArr[0]}
              />
            </Card>
          </div>
        );
      });
  }

  public done(): void {
    this.redirectBack();
  }

  public getAgencyFeeDialogTitle(): string {
    return this.trans("dialog/agreement-title");
  }

  public switchTab = (event, tabValue): any => {
    event

    this.setState({
      selectedTabIndex: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_UNIT_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue,
        unitId: this.state.id
      }
    });
  }

  public setActive = () => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_SET_ACTIVE_START,
        payload: {
          active: true,
          unitId: this.state.unit && this.state.unit.id
        },
        onSuccess: () => this.setState({ isSaving: false, active: true }),
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public renderInfoTab = () => {
    return (
      <div>
        <div className="component" style={{ boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)" }}>
          <UnitCard
            {...this.props}
            key={`unitcard-${this.state.unit?.id}`}
            unit={this.state.unit}
            unitIdForDetailsPresentation={this.state.unitIdForDetailsPresentation}
            mainCardPresentation={true}
            removed={this.state.removed}
            attachments={this.state.attachments}
            amazonFolderName={this.state.amazonFolderName}
            unitServiceStatus={this.state.unitServiceStatus}
            unitServiceStatusDilaogOpen={this.state.unitServiceStatusDilaogOpen}
            unitType={this.state.unitType}
            unitNumber={this.state.unitNumber}
            squareMeters={this.state.squareMeters}
            roomNumber={this.state.roomNumber}
            bedroomNumber={this.state.bedroomNumber}
            bathroomNumber={this.state.bathroomNumber}

            changeUnitType={this.changeUnitType}
            changeUnitNumber={this.changeUnitNumber}
            changeUnitSquareMeters={this.changeUnitSquareMeters}
            changeUnitRoomNumber={this.changeUnitRoomNumber}
            changeUnitBedroomNumber={this.changeUnitBedroomNumber}
            changeUnitBathroomNumber={this.changeUnitBathroomNumber}
            updateUnitServiceStatus={this.updateUnitServiceStatus}
            changeUnitIdForDetailsPresentation={id => this.setState({ unitIdForDetailsPresentation: id })}
            changeAddressButton={
              <Button
                color="primary"
                style={{ padding: "4px 10px", marginLeft: "12px", lineHeight: "normal", whiteSpace: "nowrap", border: "1px solid" }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.setState({
                    openCoachMoveUnit: true
                  })
                }}
              >
                {this.trans("change-address")}
              </Button>
            }
          />
        </div>

        {
          this.state.unit?.contracts?.length > 0 && (
            <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
              <ContractListing
                {...this.props}
                contracts={this.state.unit?.contracts?.filter(contract => !contract?.removed && contract?.isActive) || []}
                unitId={this.state.unit && this.state.unit.id}
                dispatch={this.props.dispatch}
                unitInactiveOpenDialog={this.openUnitInactiveDialog}
                eventsForContracts={this.state.eventsForContracts}
                disabled={this.state.removed}
                hideButton={true}
              />
            </div>
          )
        }

        <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
          <Card className="card no-padding">
            <div>
              <div>
                {
                  this.state.unit && this.state.unit.defaultAgencyFees && this.state.unit.defaultAgencyFees
                    .filter((agencyFee: AgencyFeeInterface) => !agencyFee.isEnded)
                    .map((agencyFee: AgencyFeeInterface) => {
                      return (
                        <div className="component-wrapper no-margins has-margin-bottom">
                          <div className="component">
                            <AgreementCard
                              {...this.props}
                              key={`agreement-${agencyFee?.id}`}
                              agencyFee={agencyFee}
                              updateAgencyFee={() => this.redirect(`/app/agreement/update/${agencyFee?.id}`)}
                              removeAgencyFee={agencyFee => this.setState({ agencyFee: agencyFee, isAgencyRemoveDialog: true })}
                              openedByDefault={true}
                            />
                          </div>
                        </div>
                      );
                    })
                }
              </div>
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
          <Card className="card no-padding">
            <div>
              {
                this.state.unit?.chargeTemplates
                  .map((chargeTemplate: ChargeTemplateInterface) => {
                    return (
                      <div className="component-wrapper no-margins has-margin-bottom">
                        <div className="component">
                          <ChargeTemplateCard
                            key={`chargeTemplate-${chargeTemplate?.id}`}
                            chargeTemplate={chargeTemplate}
                            openChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate))}
                            removeChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.deleteChargeTemplate(this.state.selectedChargeTemplate))}
                          />
                        </div>
                      </div>
                    );
                  })
              }
            </div>
          </Card>
        </div>

        <div>
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            possibilityToSetAvatar={true}
            title={this.trans("attachments-for-unit")}
            amazonFolderName={this.props.amazonFolderName}
            relation="unitId"
            entity={this.state.unit}
            attachments={this.state.attachments}
            updateParentState={attachments => this.setState({ attachments: attachments })}
            onChangeAvatar={avatar => { (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar) }}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            disabled={!!this.state.unit ? this.state.unit.removed : false}
          />
        </div>
      </div>
    );
  }

  public componentDidUpdate() {
    const hash = this.props.location && this.props.location.hash && this.props.location.hash.replace("#", "");
    if (hash) {
      const node = ReactDOM.findDOMNode(this.refs[hash]);
      if (node) {
        (node as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
      }
    }
  }

  public getDefaultChargeTemplatePopupTitle = () => {
    if (this.state.isUpdating) {
      return this.trans("dialog/defaultchargetemplatesdetails-title")
    } else {
      return this.trans("dialog/newdefaultchargetemplates-title")
    }
  }

  public getChargeTemplatePopupTitle = () => {
    if (this.state.isUpdating) {
      return this.trans("dialog/chargetemplatesdetails-title")
    } else {
      return this.trans("dialog/newchargetemplates-title")
    }
  }

  public changeFilterChargeValue = (event) => {
    const choice = event.target.value;

    this.setState({
      filterValue: choice
    }, () => {
      this.fetchUnitCharges(this.state.unit && this.state.unit.id);
      this.fetchUnitContractsCharges(this.state.unit && this.state.unit.id);
    });
  }

  public renderFinanceTab = () => {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-bottom">
          <RadioGroup
            name="unitsFilters"
            className="filters-container aling-to-left"
            value={this.state.filterValue}
            onChange={this.changeFilterChargeValue}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              backgroundColor: "rgb(255, 255, 255)",
            }}
          >
            <FormControlLabel
              value="all"
              control={<Radio color="primary" />}
              label={this.trans("unitupdate-tab/finance-radiobutton/all")}
              style={{ width: "75px" }}
            />
            <FormControlLabel
              value="unpaid"
              control={<Radio color="primary" />}
              label={this.trans("unitupdate-tab/finance-radiobutton/unpaid")}
              style={{ width: "120px" }}
            />
          </RadioGroup>

          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("section/balance-title/balanceforunit")}
              </h3>

              <Button
                color="primary"
                onClick={() => {
                  if (this.checkProcessIsBusy({
                    action: "create",
                    entityName: "charge",
                    entity: this.state.unit
                  })) {
                    this.openIsBusyPopup();
                  } else {
                    this.props.dispatch({
                      type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                      payload: {
                        unitId: this.state.unit && this.state.unit.id
                      }
                    });

                    this.openChargeCreatePopup(this.state.unit);
                  }
                }}
                disabled={this.state.removed}
              >
                {this.trans("section/balance-button/newcharge")}
              </Button>
            </div>
            <BalanceComponent
              {...this.props}
              balanceFor="unit"
              balanceCharges={this.state.charges}
              deleteCharge={this.deleteCharge}
              fetchCharges={() => {
                this.fetchUnitCharges(this.state.unit && this.state.unit.id);
              }}
              unitId={this.state.unit && this.state.unit.id}
            />
          </Card>
          <div style={{ marginTop: "20px" }}>
            {this.renderUnitContractsBalanceSection()}
          </div>
        </div>
      </div>
    );
  }

  public renderContractsTab = () => {
    return (
      <div>
        <div style={{ marginTop: "20px" }} className="component-wrapper no-margins has-margin-bottom no-shadow">
          <ContractListing
            {...this.props}
            contracts={this.state.unit?.contracts || []}
            unitId={this.state.unit && this.state.unit.id}
            dispatch={this.props.dispatch}
            unitInactiveOpenDialog={this.openUnitInactiveDialog}
            eventsForContracts={this.state.eventsForContracts}
            disabled={this.state.removed}
            hideButton={true}
          />
        </div>
      </div>
    );
  }

  public renderSettingsTab = () => {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-top">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("page/unitupdate-section/settings/agreement/title")}
              </h3>
              <p style={{ marginLeft: "65px", fontSize: "12px", marginTop: "-15px", color: "gray" }}>
                {this.trans("page/unitupdate-section/settings/agreement/subtitle")}
              </p>
            </div>
            <div>
              {
                <div style={{ padding: "20px 10px 20px 65px", maxWidth: "420px" }}>
                  <Select
                    className={`form-element full-size form-input scroll-to-unitTypeId ${this.state?.assignmentServiceStatus ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("assignmentServiceStatusId")}
                    value={this.state?.assignmentServiceStatus}
                    onChange={this.changeAssignmentServiceStatus}
                    htmlFor="assignmentServiceStatusId"
                    label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
                    name="assignmentServiceStatus"
                    id="assignmentServiceStatus"
                  >
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
                  </Select>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", width: "70%", marginRight: "10px" }}>
                      <TextField
                        autoComplete="off"
                        className="full-size scroll-to-fixedFee"
                        type="text"
                        label={this.trans("dialog/agencyfee-field/fixedfee-label")}
                        value={this.state?.fixedFee}
                        onChange={this.changeFixedFeeAmount}
                        variant="standard"
                        error={!!this.getErrorFor("fixedFee")}
                        helperText={this.getErrorFor("fixedFee")}
                      />
                    </div>

                    <Select
                      className="form-input scroll-to-currency correct-label-position"
                      style={{ width: "30%" }}
                      error={this.getErrorFor("currency")}
                      value={this.state.currency}
                      onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
                      htmlFor="currency"
                      name="currency"
                      id="currency"
                      disabled={true}
                    >
                      {this.getCurrencySelectboxes()}
                    </Select>
                  </div>
                  <div className="hint-styles-dialog" style={{ margin: "0" }}>
                    {this.trans("dialog/agencyfee-info/amount")}
                  </div>

                  <TextField
                    autoComplete="off"
                    className="form-element scroll-to-percentageFee"
                    type="text"
                    label={this.trans("dialog/agencyfee-field/percentagefee-label")}
                    value={this.state?.percentageFee}
                    onChange={this.changePercentageFeeAmount}
                    variant="standard"
                    error={!!this.getErrorFor("percentageFee")}
                    style={{ width: "calc(70% - 7px)" }}
                  />
                  {!!this.getErrorFor("percentageFee") && <div className="component-error-text">{this.getErrorFor("percentageFee")}</div>}
                  <div className="hint-styles-dialog" style={{ margin: "-14px 0 10px 0" }}>
                    {this.trans("dialog/agencyfee-info/percentagefee")}
                  </div>

                  <Select
                    className={`form-element full-size form-input scroll-to-repeat-period ${this.state?.repeatPeriod ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("repeat-period")}
                    value={this.state?.repeatPeriod}
                    onChange={this.changeRepeatPeriod}
                    htmlFor="repeatPeriod"
                    label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                    name="repeatPeriod"
                    id="repeatPeriod"
                  // disabled={this.state?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
                  >
                    {this.getRepeatPeriodAgreementSelectboxes(this.state?.assignmentServiceStatus)}
                  </Select>

                  {parseFloat(this.state.percentageFee.replace(",", ".")) > 0 && (
                    <Select
                      className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
                      error={this.getErrorFor("fixedPlusPercentageMode")}
                      value={this.state?.fixedPlusPercentageMode && this.state?.fixedPlusPercentageMode.id}
                      onChange={this.updateFPPMode}
                      htmlFor="fixedPlusPercentageMode"
                      label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
                      name="fixedPlusPercentageMode"
                      id="fixedPlusPercentageMode"
                    >
                      {
                        Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                          let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                          return (
                            <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                          );
                        })
                      }
                    </Select>
                  )}
                </div>
              }
            </div>
          </Card>
        </div>
        <div style={{ marginTop: "20px" }} className="component-wrapper no-margins has-margin-bottom no-shadow">
          <Card className="card no-padding" style={{ backgroundColor: this.state.unit?.defaultChargeTemplates.length > 0 ? "#f9f9f9" : "#FFFFFF" }}>
            <div className="label-container" style={{ marginBottom: this.state.unit?.defaultChargeTemplates.length > 0 ? "8px" : 0 }}>
              <h3 className="card-title">
                {this.trans("page/unitupdate-section/settings/charge-template/title")}
              </h3>
              <p style={{ marginLeft: "65px", fontSize: "12px", marginTop: "-15px", color: "gray" }}>
                {this.trans("page/unitupdate-section/settings/charge-template/subtitle")}
              </p>
              <Button
                color="primary"
                onClick={() => {
                  if (this.checkProcessIsBusy({
                    action: "create",
                    entityName: "contract",
                    entity: this.state.unit
                  })) {
                    this.openIsBusyPopup();
                  } else {
                    this.openDefaultChargeTemplateCreatePopup();
                  }
                }}
                disabled={this.state.removed}
              >
                {this.trans("page/unitupdate-section/settings/charge-template/add-button")}
              </Button>
            </div>
            {!this.state.unit?.defaultChargeTemplates.length &&
              <div>
                <div style={{ padding: "20px 10px 20px 65px", maxWidth: "420px" }}>
                  {this.trans("page/unitupdate-section/settings/charge-template/no-charge-templates-found")}
                </div>
              </div>
            }
            {this.state.unit?.defaultChargeTemplates.length > 0 &&
              <div style={{ padding: "0 55px" }}>
                {this.state.unit?.defaultChargeTemplates
                  .map((chargeTemplate: ChargeTemplateInterface) => {
                    return (
                      <div className="component-wrapper no-margins has-margin-bottom">
                        <div className="component">
                          <ChargeTemplateCard
                            key={`chargeTemplate-${chargeTemplate?.id}`}
                            chargeTemplate={chargeTemplate}
                            openChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.openDefaultChargeTemplateUpdatePopup(this.state.selectedChargeTemplate))}
                            removeChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.deleteChargeTemplate(this.state.selectedChargeTemplate))}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            }
          </Card>
        </div>
      </div>
    );
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state?.agreementVat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let vatPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(vatPercentage) ? this.formatter.simpleFormatNumber(Math.round(vatPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state?.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        agreementVat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      agreementVat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public changeAssignmentServiceStatus = (event) => {
    const type: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      assignmentServiceStatus: type,
      repeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      hasModifiedData: true
    });
  }

  public changeRepeatPeriod = (event) => {
    const period: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      repeatPeriod: period,
      hasModifiedData: true
    });
  }

  public updateFPPMode = (event) => {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for (const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public renderAgreementsTab = () => {
    return (
      <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
        <Card className="card no-padding">
          <div>
            <div>
              {
                this.state.unit && this.state.unit.defaultAgencyFees && this.state.unit.defaultAgencyFees
                  .map((agencyFee: AgencyFeeInterface) => {
                    return (
                      <div className="component-wrapper no-margins has-margin-bottom">
                        <div className="component">
                          <AgreementCard
                            {...this.props}
                            key={`agreement-${agencyFee?.id}`}
                            agencyFee={agencyFee}
                            updateAgencyFee={() => this.redirect(`/app/agreement/update/${agencyFee?.id}`)}
                            removeAgencyFee={agencyFee => this.setState({ agencyFee: agencyFee, isAgencyRemoveDialog: true })}
                            openedByDefault={true}
                          />
                        </div>
                      </div>
                    );
                  })
              }
            </div>
          </div>
        </Card>
      </div>
    );
  }

  public deleteCharge(charge: ChargeInterface): any {
    if (charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw") || charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DELETE_START,
        payload: {
          charge: charge
        },
        onSuccess: res => {
          this.fetchUnitCharges(this.state.unit && this.state.unit.id);
          this.fetchUnitContractsCharges(this.state.unit && this.state.unit.id);

          this.setState({
            deletedCharge: charge,
            removedPayments: res.data.data.removedPayments,
            paymentsFailedToRemove: res.data.data.paymentsFailedToRemove,
            isSaving: false
          }, () => {
            if (this.state.deletedCharge && this.state.deletedCharge.amountPaid > 0 && this.state.removedPayments && this.state.removedPayments.length === 0) {
              this.setState({
                chargeRemoveSucceedDialogOpen: true
              });
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          })
        }
      });
    })
  }

  public deletePayment(payment: PaymentInterface): any {
    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_DELETE_START,
      payload: {
        payment: payment
      }
    });
  }

  public fetchUnitContractsEvents = (unit: UnitInterface) => {
    const contractIds = unit.contracts.map(contract => contract.id);

    if (contractIds.length === 0) {
      return;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        contractIds: contractIds
      },
      onSuccess: data => {
        const eventsForContracts = [...data.events]
          .filter((event: EventInterface) => !!event &&
            event.removed === false &&
            event.hidden === false &&
            (event.eventTypeId === 16 ||
              event.eventTypeId === 21 ||
              event.eventTypeId === 33));

        this.setState({
          eventsForContracts: eventsForContracts
        });
      }
    });
  }

  public fetchUnitCharges = (unitId: number) => {
    const payload: any = {
      unitId: unitId,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    this.state.filterValue === "unpaid" ? payload.paid = 0 : null;

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: { ...payload },
      onSuccess: data => {
        this.setState({ charges: [...data.charges] });
      }
    });
  }

  public fetchUnitContractsCharges = (unitId: number) => {
    const payload: any = {
      unitId: unitId,
      chargesForContracts: 1,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    this.state.filterValue === "unpaid" ? payload.paid = 0 : null;

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: { ...payload },
      onSuccess: data => {
        this.setState({ chargesForContracts: [...data.charges] });
      }
    });
  }


  // * START * Unit 3-dots menu methods

  protected openUnitMenu = (event: any): void => {
    this.setState({
      anchorUnitEl: event.currentTarget
    });
  }

  protected closeUnitMenu = (): void => {
    this.setState({
      anchorUnitEl: null
    });
  }

  public changeActiveStatus = (unit: UnitInterface) => {
    this.closeUnitMenu();
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_SET_ACTIVE_START,
        payload: {
          active: unit.isInactive,
          unitId: unit && unit.id
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public openMemoPopup = () => {
    this.setState({
      memoPopupOpen: true,
      anchorUnitEl: null
    });
  }
  public saveDraft = (message) => {
    this.setState({
      note: message,
    })
  }

  public saveReminder = (unit: UnitInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: this.state.note
          },
        },
        onSuccess: () => this.setState({ isSaving: false, memoPopupOpen: false }),
        onError: () => this.setState({ isSaving: false, maxCharacterNumberForNotePopupOpen: true })
      });
    });
  }

  public removeReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: ""
          }
        },
        onSuccess: () => this.setState({ isSaving: false, memoPopupOpen: false }),
        onError: () => this.setState({ isSaving: false })
      });
    });
  }

  // * FINISH * Unit 3-dots menu methods

  public openChargeCreatePopup = (entity) => {
    this.setState({
      // isChargeCreatePopupOpen: true,
      selectedEntityForCharge: entity
    }, () => this.setState({
      isCoachNewChargeOpen: true
    }));
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false,
      openChargeCreatePopupLaunchPanel: false
    });
  }

  public render() {
    const contract = this.state.unit && this.state.unit?.getActiveContract();
    // const rentTemplate = contract && contract.chargeTemplates.length > 0 && contract.chargeTemplates.find(chargeTemplate => chargeTemplate.type.label === "Basic_rent");
    // const rentTemplateDisplayName = rentTemplate ? `${this.formatter.formatNumber(rentTemplate.amount, rentTemplate.currency)}` : "";
    // const contractDisplayName = contract ? `${rentTemplateDisplayName} ${this.formatter.formatDate(contract.firstDate)} - ${contract.endDate ? this.formatter.formatDate(contract.endDate) : this.trans("no-end-date")}` : "";
    // const occupant = contract ? contract.occupant : null;
    // const occupantDisplayName = occupant ? `${occupant.firstName} ${occupant.lastName} ${occupant.email} ${occupant.phone1}` : "";

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper ">
                <h1>{this.trans("unitupdate-title")}</h1>
              </div>
              <div className="button-container-small">
                {/* <FormControlLabel
                  control={
                    <Switch
                      checked={UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus}
                      onChange={() => {
                        this.saving(() => {
                          this.props.dispatch({
                            type: Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START,
                            payload: {
                              unitId: this.state.unit?.id,
                              unitServiceStatusId:  UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus ?
                              UnitServiceStatusTypeContainer.pickIdFromLabel("MANAGEMENT")
                              :
                              UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE")
                            },
                            onSuccess: unit => {
                              this.setState({
                                isSaving: false
                              });

                              if (unit) {
                                return this.setState({
                                  unitServiceStatus: unit?.unitServiceStatus?.id
                                });
                              }
                            },
                            onError: () => {
                              this.setState({
                                isSaving: false
                              });
                            }
                          });
                        })
                      }}
                      color="primary"
                      disabled={this.state.removed}
                    />
                    }
                  label={this.trans("label-archive")}
                /> */}
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{ marginRight: "20px" }}
                    >
                      {this.trans("page/entity-button/cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.redirectBack}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("page/entity-button/save") : this.trans("page/entity-button/done")}
                </Button>
              </div>
            </div>
            <div className="inner-wrapper">
              <h4>{this.state.unit && this.state.unit.displayName}</h4>
            </div>
          </div>

          <div className="box component-unit-update">
            {this.state.unit && this.state.unit.isInactive && (
              <div className="component-wrapper no-margin-top has-margin-bottom">
                <Card
                  style={{
                    boxShadow: "none"
                  }}
                >
                  <CardContent style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 20px 0px 20px",
                  }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img src={this.image.get("info")} alt="info" style={{ width: "30px", height: "30px" }} />
                      <h2 style={{ marginLeft: "15px", fontWeight: "normal" }}>{this.trans("unitupdate-section/active-status")}</h2>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.setActive}
                      disabled={this.state.removed}
                    >
                      {this.trans("unitupdate-section/active-button/activate")}
                    </Button>
                  </CardContent>
                </Card>
              </div>
            )}

            {this.state.unit && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus && (
              <div className="component-wrapper no-margin-top has-margin-bottom">
                <Card
                  style={{
                    boxShadow: "none"
                  }}
                >
                  <CardContent style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 20px 0px 20px",
                  }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img src={this.image.get("info")} alt="info" style={{ width: "30px", height: "30px" }} />
                      <h2 style={{ marginLeft: "15px", fontWeight: "normal" }}>{this.trans("unitupdate-section/archive-status")}</h2>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.archive}
                      disabled={this.state.removed}
                    >
                      {this.trans("unitupdate-section/active-button/activate")}
                    </Button>
                  </CardContent>
                </Card>
              </div>
            )}

            <div className="component-wrapper no-margin-top no-shadow">
              {/* {contract &&
                <AbstractPane
                  unitPage={true}
                  contract={contract}
                  occupant={occupant}
                  contractDisplayName={contractDisplayName}
                  occupantDisplayName={occupantDisplayName}
                />
              } */}
              <div style={{ position: "relative" }}>
                <Tabs
                  className="tab tab-simple tab-contains-3 half-size has-margin-bottom"
                  value={this.state.selectedTabIndex}
                  onChange={this.switchTab}
                >
                  <Tab label={this.trans("label-overview")} value={0}
                    onClick={() => {
                      this.fetchUnitContractsEvents(this.state.unit);
                    }}
                  />
                  <Tab label={this.trans("unitupdate-tab/finance")} value={1}
                    onClick={() => {
                      this.fetchUnitCharges(this.state.unit && this.state.unit.id);
                      this.fetchUnitContractsCharges(this.state.unit && this.state.unit.id);
                    }}
                  />
                  <Tab label={this.trans("unitupdate-tab/contracts")} value={2} />
                  <Tab label={this.trans("unitupdate-tab/agreements")} value={4} />
                  <Tab style={{ marginLeft: "auto", padding: "0 10px" }} label={this.trans("label-settings")} value={3} />
                </Tabs>
              </div>
              {this.state.selectedTabIndex === 0 && this.renderInfoTab()}
              {this.state.selectedTabIndex === 1 && this.renderFinanceTab()}
              {this.state.selectedTabIndex === 2 && this.renderContractsTab()}
              {this.state.selectedTabIndex === 3 && this.renderSettingsTab()}
              {this.state.selectedTabIndex === 4 && this.renderAgreementsTab()}
            </div>
          </div>

          <div className={"right-panel-wrapper"}>
            {
              !this.state.removed && this.state.unit && (
                <EntityLaunchpanel
                  {...this.props}
                  entityTitle={this.trans("launchpanel-unit-title")}
                  panelWithMoreButton={{ borderBottom: 0 }}
                  actionsList={
                    <List component="div" disablePadding>
                      <ListItem
                        button
                        alignItems="flex-start"
                        key={`add-extra-charge-btn`}
                        onClick={() => {
                          if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({
                              openChargeCreatePopupLaunchPanel: true
                            }, () => {
                              this.openChargeCreatePopup(this.state.unit)
                            })
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-pay"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-add-extra-charge-for-unit")} secondary={this.trans("launch-panel-unit-extra-charge-hint")} />
                      </ListItem>

                      <ListItem
                        button
                        alignItems="flex-start"
                        key={`menuitem-create-contract`}
                        onClick={() => {
                          if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            if (this.state.unit?.contracts?.some((contract: ContractInterface) => contract?.isActive && !contract?.isEnding)) {
                              this.setState({
                                isUnitHasActiveContractPopupOpen: true
                              });
                            } else {
                              this.setState({
                                openCoachCreateNewContact: true
                              })
                            }
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-contract"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-create-contract")} secondary={this.trans("hint/launch-panel-create-contract")} />
                      </ListItem>
                      
                      <ListItem
                        button
                        alignItems="flex-start"
                        key={`menuitem-create-contract`}
                        // redirect user to /app/coach/new-bill-settlement
                        onClick={() => browserHistory.push("/app/coach/new-bill-settlement")}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-contract"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-bill-settlement")} secondary={this.trans("hint/launch-panel-bill-settlement")} />
                      </ListItem>

                      <ListItem
                        button
                        alignItems="flex-start"
                        key={`menuitem-create-agreement`}
                        onClick={() => {
                          if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.openAgencyFeeDialog();
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-create-agreement")} secondary={this.trans("hint/launch-panel-create-agreement")} />
                      </ListItem>

                      <ListItem
                        button
                        alignItems="flex-start"
                        key="menuitem-create-charge-template"
                        onClick={() => {
                          if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.openChargeTemplateCreatePopup();
                          }
                        }}
                        disabled={this.state.removed}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launchpanel/unit-option/createchargetemplate")} secondary={this.trans("launchpanel/unit-option/createchargetemplate-hint")} />
                      </ListItem>

                      <ListItem
                        button
                        key={`menuitem-create-default-contract-amount`}
                        onClick={() => {
                          if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.openDefaultChargeTemplateCreatePopup();
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-create-default-contract-amount")} secondary={this.trans("launch-panel-create-default-contract-amount-hint")} />
                      </ListItem>

                      <ListItem
                        button
                        key={`add-task-btn`}
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({
                              isNewTaskPopupOpen: true,
                              anchorElCharge: null
                            })
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-task"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                      </ListItem>

                      <ListItem
                        button
                        key={`add-memo-btn`}
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorUnitEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.openMemoPopup();
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className={`icon icon-style-launch-panel ${this.state.unit?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}></div></ListItemIcon>
                        <ListItemText>{this.trans("charge-details/menuitem-open-memo")}</ListItemText>
                      </ListItem>

                      {this.state.showAllFields &&
                        <>
                          {this.state.unit?.getActiveContract() && (this.state.unit?.getActiveContract().isSigned || this.state.unit?.getActiveContract().isExpiring) &&
                            <ListItem
                              button
                              key={`increase-rent-btn`}
                              onClick={() => {
                                if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus) {
                                  this.props.dispatch({
                                    type: Constants.SNACKBAR_ADD_MESSAGE,
                                    payload: {
                                      message: this.trans("archived_unit"),
                                      type: "error"
                                    }
                                  });
                                } else if (this.state.hasModifiedData) {
                                  this.setState({
                                    isErrorLaunchPanelOpen: true,
                                    anchorUnitEl: null,
                                    openLeavePrompt: true
                                  })
                                } else {
                                  this.setState({
                                    openCoachIncreaseRent: true,
                                    anchorElCharge: null
                                  })
                                }
                              }}>
                              <ListItemIcon><div className="icon icon-ic-pay icon-style-launch-panel"></div></ListItemIcon>
                              <ListItemText primary={this.trans("launchpanel/option-adjust")} secondary={this.trans("hint/launch-panel-adjust-contract-unitpage")} />
                            </ListItem>
                          }

                          <ListItem
                            button
                            alignItems="flex-start"
                            key={`send-tenant-portal-link-btn`}
                            onClick={() => {
                              if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorUnitEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.redirect(`/app/email/send/tenant-login-portal-link/${this.state.unit?.getMostRecentNonClosedContract()?.mainTenantContactId || ""}`)
                              }
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                            <ListItemText primary={this.trans("launch-panel-send-tenant-portal-link")} secondary={this.trans("launch-panel-send-tenant-portal-link-hint")} />
                          </ListItem>

                          <ListItem
                            button
                            alignItems="flex-start"
                            key={`de-activate-btn`}
                            onClick={() => {
                              if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorUnitEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.changeActiveStatus(this.state.unit);
                              }
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-activate"></div></ListItemIcon>
                            <ListItemText primary={this.state.unit && !this.state.unit.isInactive ? this.trans("menuitem-deactivate") : this.trans("menuitem-activate")} secondary={this.state.unit && !this.state.unit.isInactive ? this.trans("menuitem-deactivate-hint") : this.trans("menuitem-activate-hint")} />
                          </ListItem>

                          <ListItem
                            button
                            alignItems="flex-start"
                            key={`de-archive-btn`}
                            onClick={() => {
                              if (UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== this.state.unitServiceStatus) {
                                this.setState({
                                  isArchivePromptOpen: true,
                                });
                              } else {
                                this.archive()
                              }

                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-activate"></div></ListItemIcon>
                            <ListItemText
                              primary={
                                this.state.unit && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== this.state.unitServiceStatus
                                  ? this.trans("menuitem-archive")
                                  : this.trans("label-unarchive")}
                              secondary={
                                this.state.unit && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== this.state.unitServiceStatus
                                  ? this.trans("menuitem-archive-hint")
                                  : this.trans("menuitem-unarchive-hint")}
                            />
                          </ListItem>
                          <ListItem
                            button
                            key={`delete-btn`}
                            onClick={() => {
                              this.setState({
                                entity: this.state.unit,
                                isDeletePromptOpen: true,
                                anchorElUnits: null
                              });
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                            <ListItemText>{this.trans("menuitem-delete-unit")}</ListItemText>
                          </ListItem>
                        </>
                      }

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: "#e6e6e6",
                          padding: "6px 0",
                          marginTop: "8px"
                        }}
                        onClick={() => this.setState({
                          showAllFields: !this.state.showAllFields
                        })}
                      >
                        {
                          this.state.showAllFields ?
                            <ExpandLess /> :
                            <ExpandMore />
                        }
                        <div>{this.state.showAllFields ? this.trans("title-less").toUpperCase() : this.trans("title-more").toUpperCase()}</div>
                      </div>
                    </List>
                  }
                />
              )
            }

            {
              this.isBeta() && (
                <Timeline
                  {...this.props}
                  relations={{ unitId: this.state.unit && this.state.unit.id }}
                  entityEvents={this.state.events}
                  fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.unit && this.state.unit.id)}
                  fetchingEvents={this.state.fetchingEvents}
                  unit={this.state.unit}
                />
              )
            }
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.getDefaultChargeTemplatePopupTitle()}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isDefaultChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"dialog/remove-contract"}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        <DeleteEntityPrompt
          {...this.props}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={() => {
            this.setState({
              isDeletePromptOpen: false
            })
          }}
          onDelete={this.delete}
        />

        <ArchiveEntityPrompt
          {...this.props}
          isOpen={this.state.isArchivePromptOpen}
          onCancel={() => {
            this.setState({
              isArchivePromptOpen: false
            })
          }}
          title={this.trans("warning-confirm-archive-title")}
          secondLine={this.trans("warning-confirm-archive-text")}
          onArchive={this.archive}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.unit}
                saveDraft={this.saveDraft}
                relations={{ unitId: this.state.unit?.id }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.unit)}
          hideCross={true}
          subtitle={this.state.unit && this.state.unit.displayName ?
            this.state.unit.displayName : ""}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ cannotDeleteSavingsChargeDialog: false })}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("create-tasks-for", { activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "" })}
          content={this.trans("you-are-about-to-create-task-for-activity-for-unit", { activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "", tenant: this.state.currentTenant, unit: this.state.unit && this.state.unit.displayName ? this.state.unit.displayName : "" })}
          openLeavePrompt={this.state.isCreateTasksFromActivityTemplatePopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("create-tasks")}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }); }}
          onSave={() => {
            this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }, () => {
              this.props.dispatch({
                type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
                payload: {
                  unitId: this.state.unit && this.state.unit.id
                }
              });

              this.redirect(`/app/activity/create/${this.state.currentActivityTemplate && this.state.currentActivityTemplate.id}/0/${this.state.unit && this.state.unit.id}`);
            })
          }}
          hideCross={true}
        />

        <ChargeCreateDialog
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          selectedEntity={this.state.selectedEntityForCharge}
          selectedCounterpartyForCharge={this.state.openChargeCreatePopupLaunchPanel ? this.state.unit?.property?.company : null}
          defaultChargeTypeId={this.state.openChargeCreatePopupLaunchPanel ? TypeContainer.pickIdFromLabel("Other_receivable") : null}
          defaultChargeTypeLabel={this.state.openChargeCreatePopupLaunchPanel ? "Other_receivable" : null}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        {this.state.isCoachNewChargeOpen && (
          <CoachNewCharge
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            selectedObjectForNewCharge={this.state.selectedEntityForCharge}
            onCloseCoach={(success: boolean = false, charge) => {
              this.setState({
                isCoachNewChargeOpen: false
              }, () => {
                if (success) {
                  return this.redirect(`/app/charge/update/${charge.id}`)
                }
              })
            }}
            selectedOwnerForNewCharge={this.state.unit?.property?.company || null}
            defaultChargeTypeId={TypeContainer.pickIdFromLabel("Other_receivable")}
            defaultChargeTypeLabel={"Other_receivable"}
          />)}

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.state.isErrorLaunchPanelOpen ? () => this.setState({ openLeavePrompt: false, hasModifiedData: false, additionalSectionHasModifiedData: false }) : this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.state.unit}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorElUnit: null
            })
          }}
        />

        {this.state.openCoachIncreaseRent &&
          <CoachIncreaseRentDialog
            {...this.props}
            openCoachIncreaseRent={this.state.openCoachIncreaseRent}
            contract={this.state.unit?.getActiveContract()}
            onCloseIncreaseRentCoach={(contract, success: boolean) => {
              this.setState({
                openCoachIncreaseRent: false
              })
              if (success) {
                return this.redirect(`/app/contract/update/${contract?.id}`);
              }
            }}
          />
        }

        {this.state.isAgencyFeeDialogOpen && this.state.isUpdating && (
          <PromptDialog
            {...this.props}
            title={this.getAgencyFeeDialogTitle()}
            subtitle={this.trans("dialog-add-agency-fee-subtitle")}
            content={this.getAgencyFeeDialogContent()}
            openLeavePrompt={this.state.isAgencyFeeDialogOpen}
            onClose={this.closeAgencyFeeDialog}
            onlyPositiveButton={false}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={true}
          />
        )}

        {this.state.isAgencyFeeDialogOpen && !this.state.isUpdating && (
          <CoachAgencyFee
            {...this.props}
            objectType={AgencyFeeContainer.pickIdFromLabel("Unit")}
            objectId={this.state.unit && this.state.unit.id}
            showDates={true}
            onSave={this.addAgencyFee}
            onCancel={this.closeAgencyFeeDialog}
            openCoach={this.state.isAgencyFeeDialogOpen}
            activeContract={contract}
          />
        )}

        <PromptDialog
          {...this.props}
          title={this.getChargeTemplatePopupTitle()}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        {this.state.openCoachMoveUnit && (
          <CoachMoveUnitDialog
            {...this.props}
            unit={this.state.unit}
            openCoachMoveUnit={this.state.openCoachMoveUnit}
            onCloseCoach={() => {
              this.setState({
                openCoachMoveUnit: false
              })
            }}
          />
        )}

        {this.state.openCoachCreateNewContact &&
          <CoachNewContractDialog
            {...this.props}
            selectedUnit={this.state.unit}
            activeStep={1}
            openCoachCreateNewContact={this.state.openCoachCreateNewContact}
            onCloseContractCoach={(contract) => {
              this.setState({
                openCoachCreateNewContact: false
              });
              if (contract?.id) {
                this.redirect(`/app/contract/update/${contract?.id}`);
              }
            }}
          />
        }

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/warning-title")}
          content={
            <div>
              <p>{this.trans("dialog/preprocess-unithasactivecontract/info")}</p>
            </div>
          }
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          openLeavePrompt={this.state.isUnitHasActiveContractPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isUnitHasActiveContractPopupOpen: false }); }}
          onSave={() => {
            this.setState({
              isUnitHasActiveContractPopupOpen: false,
              openCoachCreateNewContact: true
            });
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes,
    charges: state.charges,
    units: state.units,
    properties: state.properties,
    component: state.unitUpdate,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
    agencyFeeCreate: state.agencyFeeCreate,
    agencyFeeUpdate: state.agencyFeeUpdate
  };
};

export default connect(mapStateToProps)(
  UnitUpdate
);
